// Keys always hidden from user-facing metadata editors.
// `last_reference_media_id` sits with `reference_media_id`: it is the closing
// frame's companion id, stamped in lockstep with `last_reference_image_url` by
// internal/pipeline/assembly.go and edited through the reference-frames editor,
// never by hand.
export const HIDDEN_METADATA_KEYS = new Set([
  'original_url', 'source_url', 'reference_image_url', 'reference_media_id',
  'last_reference_media_id',
  'scene_id', 'order', 'cost', 'lip_sync_pending', 'lip_sync_source_id',
  'replacement_media_id', 'replacementMediaId', 'media_item_ref', 'mediaItemRef',
  'media_item_id', 'mediaItemId', 'needs_lip_sync', 'type',
]);

// Additional keys hidden in the storyboard detail panel (handled separately)
export const STORYBOARD_HIDDEN_METADATA_KEYS = new Set([
  'original_url', 'source_url', 'reference_image_url', 'reference_media_id',
  'last_reference_media_id',
  'scene_id', 'order', 'cost', 'lip_sync_pending', 'lip_sync_source_id',
  'replacement_media_id', 'replacementMediaId', 'media_item_ref', 'mediaItemRef',
  'media_item_id', 'mediaItemId', 'needs_lip_sync', 'type',
  'text',
  'subtitle_enabled',
]);
